import general from '../general';

/**
 * 下载事件上报
 * @param {string} download_source_id - 下载来源标识，如 "index-nav"
 * @param {string} game_id            - 游戏 ID
 */
export function reportDownloadEvent({ download_source_id, game_id }) {
  const unid = localStorage.getItem('appkey') || '';
  return general.axios.post('/downLoadEvent', {
    download_source_id,
    unid,
    game_id,
  });
}
